module.exports = __webpack_public_path__ + "img/android.e0434766.png";